export const PaymentRequestStatus = {
  SENT: 'sent',
  PAID: 'paid',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
} as const
